import {isFeatureEnabled} from '@github-ui/feature-flags'
import {ThreePanesLayout} from '@github-ui/three-panes-layout'
import {useEffect} from 'react'

import {RepoIssuesSidebar} from '../components/sidebar/RepoIssuesSidebar'
import {
  IssueIndexPage,
  IssueShowPage,
  RepositoryLabelIndexPage,
  RepositoryMilestoneIndexPage,
  RepositoryMilestonePage,
} from '../lazy-routes'

export function IssueViewsPage() {
  useEffect(() => {
    IssueIndexPage.preload()
    IssueShowPage.preload()
    RepositoryMilestoneIndexPage.preload()
    RepositoryLabelIndexPage.preload()
    RepositoryMilestonePage.preload()
  }, [])

  if (!isFeatureEnabled('issue_pinned_views') || !isFeatureEnabled('issue_pinned_views_index_page')) {
    return null
  }

  return (
    <ThreePanesLayout
      contentAs="div"
      resizeable={false}
      leftPaneWidth="medium"
      leftPane={{
        element: <RepoIssuesSidebar />,
        ariaLabel: 'Issues sidebar navigation',
      }}
      middlePane={<p>Views page</p>}
    />
  )
}
